var some = require('./some');

    /**
     * Check if object contains value
     */
    function contains(obj, needle) {
        return some(obj, function(val) {
            return (val === needle);
        });
    }
    module.exports = contains;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/contains.js
// module id = CP7b
// module chunks = 0